import { UserProfileTabId } from '../User.constants'

export const USER_PROFILE_TABS_COUNTER_SECTION_BY_TAB_ID = {
  [UserProfileTabId.Buildings]: 'buildings',
  [UserProfileTabId.Categories]: 'request_categories',
  [UserProfileTabId.Contracts]: 'contracts',
  [UserProfileTabId.Documents]: 'documents',
  [UserProfileTabId.Emails]: 'emails',
  [UserProfileTabId.Posts]: 'posts',
  [UserProfileTabId.Requests]: 'requests',
}
